export * from './src/account-view.component';
